<div class="holder">
  <div class="select">
    <mat-card>
      <mat-card-header>
        <ng-container>
          <div class="card-header" mat-card-avatar>
            <mat-icon>draw</mat-icon>
          </div>
          <mat-card-title>
            <a [routerLink]="['/', 'main', 'list']" class="header-link">Översiktsvy</a>
          </mat-card-title>
        </ng-container>
      </mat-card-header>
      <mat-card-content>
        Översikt över kommande omsättningar samt arbetsvy vid utskick av omsättningsbrev och villkorsbilagor.
      </mat-card-content>
    </mat-card>
    <mat-card>
      <mat-card-header>
        <ng-container>
          <div class="card-header" mat-card-avatar>
            <mat-icon>loyalty</mat-icon>
          </div>
          <mat-card-title>
            <a [routerLink]="['/', 'discount']" class="header-link">Ränteerbjudande</a>
          </mat-card-title>
        </ng-container>
      </mat-card-header>
      <mat-card-content>
        Hantera ränteerbjudande.
      </mat-card-content>
    </mat-card>
    <mat-card>
      <mat-card-header>
        <div class="card-header" mat-card-avatar>
          <mat-icon>work_history</mat-icon>
        </div>
        <mat-card-title>
          <a [routerLink]="['/','bindings']"
             class="header-link">Nya villkor</a>
        </mat-card-title>
      </mat-card-header>
      <mat-card-content>
        Nya villkor som ska registreras.
      </mat-card-content>
    </mat-card>
  </div>
</div>
